/* Dynamic Plot code copyright 2016 (c) Tuva Labs Inc. */
/**
 * Created by cmiller on 2016-07-25.
 */

// import {Dyn} from '../dynDataSet/dynMiscellany';
// import mediator from '../dynDataSet/mediatorUtil';

export const wrapDynPlotMeasures = function(Dyn) {
	let mediator = Dyn.mediator;

    class MeasureSet {
    /**
     * Constructor for a set of measures,
     * each set is then used to construct a table in the SummaryView
     * Used to divide measures into different tables.
     * @param setID
     * @constructor
     */
        constructor(setID) {
            "use strict";
            this.setID = setID || "std";    // a set ID used by a group of measures, e.g. "leastSQ" for least squares line measures
            this.measureNames = [];         // array measure names in all Dyn.PlotMeasures.measures that use this setID, e.g.["mean","median",..]
            this.paramSets = {};            // some tables have sets of unique values, e.g. row IDs to distinguish one Movable Line from another.
            this.counts = {};               // counts of number of measures using each parameter in Dyn.PlotMeasures.knownMeasureParams[], e.g. { mean:5, median:2 }
            this.hiddenIDs = [];            // array of hidden parameters for measures, not shown in cell data, e.g.  [ "hiddenLineID" ]
        }
    } // class MeasureSet
    Dyn.MeasureSet = MeasureSet;

    class PlotMeasures {
        /**
         * Constructor holding sets of measures calculated by the plot.
         * Measures are statisical values like mean, median, count.
         * Measures are often repeated for each of mutlple categories, attributes, plot sections, etc.
         * Intended as the model used to build the table of summary statistics associated with the plot.
         */
         constructor ( dataSet ) {
            "use strict";

            this.dataSet = dataSet;         // reference to data set for plot elements {Dyn.DataSet}
            this.measures = {};             // Set of measure value arrays { controlsCount: [], controlsPercentage:[] }
                                            // each array contains values like { value:"12.345", measureName:"mean", xAttributeID:"height", yBinName:"male" }
            this.missingValuesForMeasures = {}; // special missing values, e.g. { "Count":"0" } or { "percento":"0%" } for table use instead of blank cell.
            this.publishedCheckSum = "";    // checksum for each set of measures, so we know when measures have changed (see publishUpdates())

            // data for structuring the summary table of measures, referenced by this.measures (above)
            this.xAttributeIDs = [];        // Array of Dyn.Attribute.id, for attributes active on X-axis
            this.yAttributeIDs = [];        // Array of Dyn.Attribute.id, for attributes active on Y-axis
            this.cAttributeIDs = [];        // Array of Dyn.Attribute.id, for color attributes (attributes active on legend)
            this.xBinNames = [];            // Array of category names on X-axis, if any
            this.yBinNames = [];            // Array of category names on Y-axis, if any
            this.cBinNames = [];            // Array of category names on Color axis (in legend, or in Pie/Bar section)
            this.divBinNames = [];          // Array of bin names created by Dividers (e.g. ["0-9", "10-19"] created by Dyn.DividersElement)
            this.histoBinNames = [];         // Array of histogram bin names (created by Dyn.HistoElement)
            this.cBinNamesHeading = "";     // if non-empty, the attribute ID to use as the heading for .cBinNames in table
            this.sets = [];                 // Array of measure sets ({ measureNames, counts, setID }), each set is the raw data for a single SummaryView table.
        }

        // list of known measure parameters used by callers to addToMeasuresArray(); these known measures get counted
        get knownMeasureParams() { return [
            "setID", "measureName", "value", "attributeID",
            "xBinIndex", "yBinIndex", "cBinIndex",
            "divBinIndex", "histoBinIndex" ]; }

        // list of known measure parameters used by callers to addToMeasuresArray(); these known measures form sets of unique values
        get knownParamSets() { return [ "lineID", "modelNumber" ]; }

        // list of known measure parameters that are used has ID but not visible in table, e.g. compare "lineID" to "hiddenLineID"
        get knownHiddenIDs() { return [ "hiddenLineID" ]; }

        // list of set IDs, each set of measures with the same ID gets converted to a table by the Summary View.
        get knownSetIDs() { return [
            "leastSq", "cell", "histo", "pie", "bar", "divider",
            "std", "referenceLine", "movableLine", "modelFunction", "ruler" ]; }

        // subset of knownSetIDs where the measures form the columns of the table. If a set is not in this list,
        //      the measures of the measure set may form the rows or the title of the table.
        get setIDsWithMeasuresInColumns() { return [
            "leastSq", "referenceLine", "movableLine", "modelFunction", 'ruler' ]; }

        get tableTitles() { return {
            /* setID    :   title */
            "blank":    "Add a function from the toolbar to activate the summary table",
            "std":      "Measures", // mean median mode st-dev boxplot
            "cell":     "Count/Percent", // count+percent of cells formed from X+Y bins ("Count Cases" or "Count by Category")
            "histo":    "Histogram",
            "pie":      "Pie Chart",
            "bar":      "Bar Chart",
            "divider":  "Dividers",
            "leastSq":  "Least Squares Line",
            "referenceLine":    "Reference Line",
            "movableLine":      "Movable Line",
            "modelFunction":    "f(x) Models",
            'ruler':    "Ruler"
        }; }

        // report of all significant measure values, for this.publishedCheckSum and for debugging
        toString() {

            var measuresString = "",
                setsString ="",
                knownParams = this.knownMeasureParams;

            function addToString( measureValue, measureIndex ) {
                knownParams.forEach( function( paramName, paramIndex ) {
                    if( measureValue.hasOwnProperty( paramName )) {
                        measuresString += (paramIndex === 0) ? "{ " : ", ";
                        measuresString += paramName+":"+measureValue[paramName];
                    }
                });
                measuresString += " }";
            }

            this._forEachMeasure( addToString );
            this.sets.forEach( function( value, index ) {
                setsString += " setID:"+value.setID;
                setsString += " measureNames:"+value.measureNames.toString();
            });
            return 'PlotMeasures:{'+
                " xAttributeIDs["+this.xAttributeIDs.toString()+
                "], yAttributeIDs:["+this.yAttributeIDs.toString()+
                "], cAttributeIDs:["+this.cAttributeIDs.toString()+
                "], xBinNames:["+this.xBinNames.toString()+
                "], yBinNames:["+this.yBinNames.toString()+
                "], cBinNames:["+this.cBinNames.toString()+
                "], divBinNames:["+this.divBinNames.toString()+
                "], histoBinNames:["+this.histoBinNames.toString()+
                "], measures:["+measuresString+
                "], sets:["+setsString+
                '] }';
        }

        /**
         * Get or create the array of measures for the elementType ("controlsPercentage", etc.)
         * @param elementType {String} -- value in enum Dyn.EPlotControl indicating the Dyn.PlotElement control type
         */
        getMeasuresArray ( elementType ) {
            Dyn.assert( typeof elementType === "string" && /controls*/.test( elementType ));
            if( ! (elementType in this.measures )) {
                this.measures[elementType] = [];
            }
            Dyn.assert( elementType in this.measures );
            return this.measures[elementType];
        }

        /**
         * Remove the array of measures for the elementType ("controlsPercentage", etc.)
         * @param elementType {String} -- value in enum Dyn.EPlotControl indicating the Dyn.PlotElement control type
         */
        removeMeasuresArray ( elementType ) {
            Dyn.assert( typeof elementType === "string" && /controls*/.test( elementType ));
            if( elementType in this.measures ) {
                if( this.measures[elementType].length > 0 ) {
                    //console.log( "PlotAdornments.removeAdornmentsArray: type=" + elementType + " length=" + this.measures[elementType].length )
                }
                delete this.measures[elementType]; // remove array of measures
            }
            Dyn.assert( !( elementType in this.measures ));
        }

        /**
         * Add a measure to a measureArray, and check/modify parameters so that findMatchingMeasures() can retrieve it
         * @param measuresArray -- the measures array for a specific PlotElement (see getMeasuresArray())
         * @param oneMeasure -- the measure data to add
         * @param [xBinIndex] -- optional bin data to check
         * @param [yBinIndex]
         * @param [cBinIndex]
         */
        addToMeasuresArray ( measuresArray, oneMeasure, xBinIndex, yBinIndex, cBinIndex ) {
            this.addOptions( oneMeasure, xBinIndex, yBinIndex, cBinIndex );
            this.checkKnownMeasureParams( oneMeasure );
            measuresArray.push( oneMeasure );
        }

        /**
         * Add the newMeasures if oldMeasureIndex === -1, or replace the measures at oldMeasureIndex
         * (i.e. do a splice on the measuresArray, as an alternative to addToMeasuresArray()
         * @param measuresArray
         * @param oneMeasure
         * @param oldMeasureIndex
         * @param measuresArray
         * @param newMeasures
         * @param oldMeasureIndex
         * @param [xBinIndex]
         * @param [yBinIndex]
         * @param [cBinIndex]
         */
        addToOrUpdateMeasuresArray ( measuresArray, newMeasures, oldMeasureIndex, xBinIndex, yBinIndex, cBinIndex ) {
            let insertIndex = (oldMeasureIndex >= 0 )? oldMeasureIndex : measuresArray.length,
                numToDelete = (oldMeasureIndex >= 0 )? newMeasures.length : 0;
            newMeasures.forEach( m => {
                this.addOptions( m, xBinIndex, yBinIndex, cBinIndex );
                this.checkKnownMeasureParams( m );
            });
            // replace the old measures at insertIndex with the new measures,
            // or if no old measures just add the new measures to the array
            measuresArray.splice.apply( measuresArray, [insertIndex, numToDelete].concat( newMeasures ));
        }

        addOptions ( oneMeasure, xBinIndex, yBinIndex, cBinIndex ) {
            if( this.xBinNames.length > 0 && isFinite( xBinIndex )) {
                oneMeasure.xBinIndex = xBinIndex;
            }
            if( this.yBinNames.length > 0 && isFinite( yBinIndex )) {
                oneMeasure.yBinIndex = yBinIndex;
            }
            if( this.cBinNames.length > 0 && isFinite( cBinIndex )) {
                oneMeasure.cBinIndex = cBinIndex;
            }
        }

        /**
         * Check to make sure our list of known parameters matches actual parameters used by callers to addToMeasuresArray().
         * If assert fails, then we want to add to our known list,
         * and possibly modify summaryTableView._analyzeRowsColumns() which expects to shape table based on known parameters.
         * @param oneMeasure
         */
        checkKnownMeasureParams ( oneMeasure ) {
            var knownParams = this.knownMeasureParams,
                knownParamSets = this.knownParamSets,
                knownSetIDs = this.knownSetIDs,
                knownHiddenIDs = this.knownHiddenIDs;

            for( var paramName in oneMeasure) {
                if( oneMeasure.hasOwnProperty( paramName )) {
                    Dyn.assert( knownParams.includes( paramName )
                        || knownParamSets.includes( paramName )
                        || knownHiddenIDs.includes( paramName),
                        "unknown parameter ADD TO Dyn.PlotMeasures.prototype.knownMeasureParams: "+paramName );
                }
            }
            if( oneMeasure.hasOwnProperty( "setID" )) {
                Dyn.assert( knownSetIDs.indexOf( oneMeasure.setID )>=0, "unknown setID ADD TO Dyn.PlotMeasures.prototype.knownSetIDs: "+oneMeasure.setID );
            }
        }

        /**
         * Update the list of attributes which have measures.  Typically called by the plot view.
         * @param attributeArrayOnX -- active X-axis attribute IDs
         * @param attributeArrayOnY -- active Y-axis attribute IDs, includes Y1 and Y2 attributes if Dual Axis plot
         * @param attributeArrayOnC -- active color attribute ID if any, a.k.a. legend attribute or selected attribute
         */
        setAttributeIDs ( attributeArrayOnX, /*numActiveX,*/ attributeArrayOnY, /*numActiveY,*/ attributeArrayOnC, /*numActiveOnC*/ ) {
            this.xAttributeIDs = attributeArrayOnX.map( attr => attr.id );
            this.yAttributeIDs = attributeArrayOnY.map( attr => attr.id );
            this.cAttributeIDs = attributeArrayOnC.map( attr => attr.id );
        }

        // set or reset the x, y, and color category names,
        // which should match the X and Y-axis bin names, and category names shown in the legend.
        setBinNames( categoriesOnXArray, categoriesOnYArray, colorAttribute ) {
            this.xBinNames = categoriesOnXArray;
            this.yBinNames = categoriesOnYArray;
            if( colorAttribute ) {
                if( colorAttribute.hasNumericIntervals()) {
                    this.cBinNames = colorAttribute.numericIntervals.categories;
                    this.cBinNamesHeading = colorAttribute.name;
                } else {
                    this.cBinNames = colorAttribute.stats.categories;
                    this.cBinNamesHeading = "";
                }
            } else {
                this.cBinNames = [];
                this.cBinNamesHeading = "";
            }
        }

        /**
         * set the names of the N+1 divider bin names created by the N dividers in the plot, if any.
         * Note that if there are N dividers on X, and M category bins on Y, there will be ((N+1) x M) bin names.
         * @param binNameArray
         */
        setDividerBinNames( binNameArray ) {
            this.divBinNames = binNameArray;
        }

        /**
         * set the names of the histogram bin names created by the histograms in the plot, if any.
         * Note that if there are N histogram bins on X, and M category bins on Y, there will be N x M bin names.
         * @param binNameArray
         */
        setHistogramBinNames( binNameArray ) {
            this.histoBinNames = binNameArray;
        }

        /**
         * Rebuild the set of unique measure names in each table
         * from the list of measures that have been collected and their setID.
         *
         * Updates: this.sets {Array of Dyn.MeasureSet}
         * From data in: this.measures
         */
        setMeasureNames() {
            var knownParams = this.knownMeasureParams,
                knownSets = this.knownParamSets,
                knownHiddenIDs = this.knownHiddenIDs,
                setOfSets = {},
                measuresArraysSorted = [];

            // erase old measure names
            this.sets = [];

            // build sortable array of plot elements that have measures
            for( var plotElementType in this.measures ) {
                if( /controls*/.test( plotElementType )) {  // is it a plot element type like "controlsMean, controlsCount" (Dyn.EPlotControl)
                    var priority = Dyn.EMeasurePriority[plotElementType];
                    Dyn.assert( priority, "Priority '"+plotElementType+"' is not defined in Dyn.EMeasurePriority");
                    measuresArraysSorted.push( { controlType:plotElementType, priority:priority, measuresArray:this.measures[plotElementType] });
                }
            }

            // sort plot element data (e.g. measures for countElement, measures for meanElement, etc)
            function comparePlotElementByMeasurePriority( a, b) {
                // usual <0, 0, >0 sorting for ascending priority values
                return a.priority - b.priority;
            }
            measuresArraysSorted.sort( comparePlotElementByMeasurePriority );

            // visit all measure arrays and create temporary setOfSets (map of setID to set)
            measuresArraysSorted.forEach( function( value ) {
                value.measuresArray.forEach( function( measureData ) {
                    Dyn.assert( measureData.measureName.length > 0, "measure is missing 'measureName' parameter" );

                    // create or update set
                    var setID = measureData.setID || "std",
                        set = setOfSets[ setID ] || new Dyn.MeasureSet( setID );
                    if( ! setOfSets.hasOwnProperty( setID )) { // save new set if not yet encountered
                        setOfSets[setID] = set;
                    }
                    if ( set.measureNames.indexOf( measureData.measureName ) === -1 ) {
                        set.measureNames.push( measureData.measureName ); // add to list of measures in this set
                    }

                    // also update count of measure params (e.g. how many measures have an "xBinIndex" parameter)
                    knownParams.forEach( function ( paramName /*, paramIndex */ ) {
                        if ( measureData.hasOwnProperty( paramName ) ) {
                            var setCount = set.counts[paramName] || 0;
                            set.counts[paramName] = setCount + 1; // update count of measures of this type in set (e.g. 6 "mean" measures in set).
                        }
                    } );
                    // add to any sets of values for those measure paramSets that we want to form sets from (see PlotMeasures.knownParamSets)
                    knownSets.forEach( paramName => {
                        if ( measureData.hasOwnProperty( paramName ) ) {
                            let paramSet = set.paramSets[ paramName ] || [],
                                paramValue = measureData[paramName];
                            if( ! paramSet.includes( paramValue )) {
                                paramSet.push( paramValue ); // add a new unique value to the set
                                set.paramSets[ paramName ] = paramSet; // save if array was just created
                            }
                        }
                    });
                    // find any hidden IDs and add to set
                    knownHiddenIDs.forEach( paramName => {
                        if( measureData.hasOwnProperty( paramName ) && ! set.hiddenIDs.includes( paramName )) {
                            set.hiddenIDs.push( paramName ); // save, so we know this set uses this parameter
                        }
                    })
                });
            });

            // save array of sets (convert from temporary setOfSets)
            for( var paramName in setOfSets ) {
               if( setOfSets.hasOwnProperty( paramName )) {
                   var set = setOfSets[ paramName ];
                   set.setID = paramName;
                   this.sets.push( set );
               }
            }
        }

        /**
         * Private function to iterate through each measure in this.measures.
         * NOTE: the controlType of the PlotElement (e.g. "controlsMean", is not visible to callers, but measureName ("Mean") is.
         * @param eachMeasureFunction -- function( index, value ) where value is
         */
        _forEachMeasure( eachMeasureFunction ) {
            // for each plot element type (key is string in Dyn.EPlotControl)
            for( var plotElementType in this.measures ) {
                if( /controls*/.test( plotElementType )) {  // is it a plot element type like "controlsMean, controlsCount" (Dyn.EPlotControl)
                    this.measures[plotElementType].forEach( eachMeasureFunction ); // iterate through Array of measures controlled by the plot element
                }
            }
        }

        /**
         * Notify the views, if our measures have changed since the last notification.
         * We use a checksum of a long measures report string to verify that something has actually changed,
         * before publishing our update.
         */
        publishUpdates() {
            var newCheckSum = Dyn.dataUtil.checksum( this.toString()); // IMPORTANT: this.toString must contain all significant table changes

            if( this.publishedCheckSum !== newCheckSum ) {
                // console.log( this.toString());
                this.publishedCheckSum = newCheckSum;
                mediator.publish( "plot:measuresUpdated", this );
            }
        }

        /**
         * Search all of our measures and return an array of measures that match the given selectors object.
         *   e.g. selector : { measureName: 'mean', attributeID: 'age1', xBinName:'Canada' }
         *   matches measure: { measureName: 'mean', attributeID: 'age1', xBinName:'Canada', value: 39.7 }
         * Selectors is an object with parameters selected from Dyn.PlotMeasures.prototype.knownMeasureParams
         * A measure object matches the selector object if they both have the same parameter names, and the parameter values match.
         * A measure object does not match the selector if either the selector or the measure is missing a parameter that the other has,
         *      ignoring the 'value' parameter, which has the resulting cell value to be displayed in the summary table.
         * @param selectors {} -- object with params to match
         * @returns {Array} -- of matching MeasuresArray values.
         */
        findMatchingMeasures( selectors ) {
            var foundMeasures = [],
                numCBins = this.cBinNames.length,
                knownHiddenIDs = this.knownHiddenIDs;

            // return true if the given measure matches the selectors
            //      Note that each measure determines which selectors it needs
            function addMeasureIfMatchesAllSelectors( measureObject /*, indexInMeasureArray */ ) {
                var success                = true, // assume measure matches selectors until we find one exception
                    hasNoMatchingSelectors = true, // true until we find one selector matches this measure
                    param;

                // does the value of all parameters in 'selectors' match the value in measure?
                for ( param in selectors ) {
                    if ( selectors.hasOwnProperty( param ) ) {
                        if ( selectors[param] === measureObject[param] ) {
                            hasNoMatchingSelectors = false;
                        } else if ( param === 'cBinIndex' && selectors[param] >= numCBins && !measureObject.hasOwnProperty( 'cBinIndex' ) ) {
                            // do nothing, cBinIndex selector of index===cBinNames.length matches measures with no cBinIndex
                        } else {
                            success = false;
                        }
                    }
                }

                // then eliminate false positives
                if ( hasNoMatchingSelectors ) {
                    success = false; // reject if no selectors or no matching selectors
                } else {
                    // have all parameters in this measure object been checked against selectors?
                    for ( param in measureObject ) {
                        if ( measureObject.hasOwnProperty( param ) &&
                             ! selectors.hasOwnProperty( param )) {
                            switch( param ) {
                            case 'value':
                            case 'setID':
                                // ignore these parameters
                                break;
                            default:
                                if( ! knownHiddenIDs.includes(param)) { // also ignore hidden IDs
                                    // reject if measure has selector (e.g. 'attributeID') but selector does not
                                    success = false;
                                }
                            }
                        }
                    }
                }

                // save this measure if success
                if( success ) {
                    foundMeasures.push( measureObject );
                }
            }

            this._forEachMeasure( addMeasureIfMatchesAllSelectors );
            return foundMeasures;
        }

        getAttributeNameFromID( attributeID ) {
            var attributeObj = this.dataSet.getAttributeByID( attributeID );
            return attributeObj ? this.dataSet.getAttributeByID( attributeID ).name : null;
        }

        /**
         * Set the missing value to use for certain measure types.
         * E.g. "Count" : "0"
         * @param measureName {string} - translated measure name
         * @param missingValueString {string} - translated cell value string
         */
        setMissingValueForMeasure( measureName, missingValueString ) {
            this.missingValuesForMeasures[ measureName ] = missingValueString;
        }

        /**
         * Get the cell value for this measure in the summary table, if the cell value is not found by findMatchingMeasures()
         * @param selector
         * @returns {string}
         */
        getMissingValueForMeasure( selector ) {
            var value = this.missingValuesForMeasures[selector.measureName];
            if ( typeof value === "string" && !
                    (selector.cBinIndex && selector.cBinIndex >= this.cBinNames.length )) // exclude "total" bin if missing
                return value;
            else
                return "";
        }

        getBinNameForTotal() {
            return Dyn.loc("Total");
        }

        getNameOfColorMeasure() {
            // for Summary View, to identify which cell should have a color display (via custom HTML)
            return Dyn.loc("Color");
        }

        getNameOfFormulaMeasure() {
            // for Summary View, to identify which cell should have a formula display (via custom HTML)
            return Dyn.loc("f(x)");
        }

        /**
         * Get the plot measures data in a format useful for saving with the plot state,
         * for answer checking, e.g. what is the slope of the movable line?
         */
        exportMeasures() {
            return Dyn.dataUtil.clone( this.measures );
        }

        /** Convert one measure to a set of part names, use by PlotElement.getPlotSummary() to construct a sentence for a measure */
        oneMeasureToPlotSummary( oneMeasure ) {
            let parts = Object.assign({},oneMeasure); // shallow copy to get started e.g. { measureName:"mean", value:12.345, attributeID:"age1", xBinIndex:2, yBinIndex:0 }
            for( let key in oneMeasure ) {
                switch( key ) {
                    case "xBinIndex":
                        parts.xBinName = this.xBinNames[ oneMeasure.xBinIndex ];
                        parts.xAttrName = this.getAttributeNameFromID( this.xAttributeIDs[0] ); // assume first X attribute
                        Dyn.assert( parts.xBinName && parts.xAttrName, "xBinName or xAttrName is missing" );
                        break;
                    case "yBinIndex":
                        parts.yBinName = this.yBinNames[ oneMeasure.yBinIndex ];
                        parts.yAttrName = this.getAttributeNameFromID( this.yAttributeIDs[0] ); // assume first Y attribute
                        Dyn.assert( parts.yBinName && parts.yAttrName, "yBinName or yAttrName is missing" );
                        break;
                    case "attributeID":
                        parts.attributeName = this.getAttributeNameFromID( oneMeasure.attributeID );
                        Dyn.assert( parts.attributeName, "attributeName is missing" );
                        break;
                }
            }
            // Dyn.debugging && console.log( "oneMeasureToPlotSummary", oneMeasure, parts );
            return parts;
        }

    } // class PlotMeasures
    Dyn.PlotMeasures = PlotMeasures;

} // wrapDynPlotMeasures
